// src/hooks/useInstallApp.js
// The installable app (3.52.0). Android and computer Chrome/Edge offer an
// install prompt we can open from a button; iPhone and iPad can't (Apple
// allows only Share → Add to Home Screen), so there we show a short guide.
//   const { installed, canInstall, iosGuide, install } = useInstallApp();
// installed: opened as the installed app; canInstall: show "Install the app";
// install(): opens the browser's prompt, or returns 'ios' to show the guide.
import { useEffect, useState } from 'react';

// The browser fires this once, maybe before React is ready: keep it here
let deferred = null;
const listeners = new Set();
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', e => { e.preventDefault(); deferred = e; listeners.forEach(f => f()); });
  window.addEventListener('appinstalled', () => { deferred = null; listeners.forEach(f => f()); });
}

export const isInstalledApp = () => typeof window !== 'undefined'
  && (!!window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true);
const isIos = () => typeof navigator !== 'undefined'
  && (/iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export default function useInstallApp() {
  const [, bump] = useState(0);
  useEffect(() => { const f = () => bump(n => n + 1); listeners.add(f); return () => listeners.delete(f); }, []);
  const installed = isInstalledApp();
  const iosGuide = !installed && isIos();
  const canInstall = !installed && (!!deferred || iosGuide);
  async function install() {
    if (deferred) {
      const e = deferred;
      deferred = null;
      try { await e.prompt(); await e.userChoice; } catch { /* closed */ }
      listeners.forEach(f => f());
      return 'prompt';
    }
    return iosGuide ? 'ios' : null;
  }
  return { installed, canInstall, iosGuide, install };
}
